/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index timeline to autogenerate all the components and extensions
 * Used by "prepareTimelines"
 */

import Timeline from './timeline/Timeline'
export * from './timeline/Timeline'
export default Timeline
